import AdminPage from "./AdminPage";

type AdminChallengePageProps = {
  challengeId: number;
  challengeRouteMode: "edit" | "results";
  challengeName?: string;
  challengeStatus?: "pending" | "started" | "finished";
  challengeType?: "challenge" | "super8" | "poco" | "tournament";
  challengeParticipantsCount?: number;
  challengeScheduledAt?: string | null;
};

export default function AdminChallengePage({
  challengeId,
  challengeRouteMode,
  challengeName,
  challengeStatus,
  challengeType,
  challengeParticipantsCount,
  challengeScheduledAt,
}: AdminChallengePageProps) {
  const historyTypeFilterFromRoute =
    String(challengeType || "").trim().toLowerCase() === "tournament"
      ? "tournament"
      : undefined;
  return (
    <AdminPage
      challengeIdFromRoute={challengeId}
      challengeRouteMode={challengeRouteMode}
      historyTypeFilterFromRoute={historyTypeFilterFromRoute}
      challengeRouteParams={{
        challengeName,
        challengeStatus,
        challengeType,
        challengeParticipantsCount,
        challengeScheduledAt: challengeScheduledAt || null,
      }}
    />
  );
}
